import { render } from "./ProjectDetailPage.vue?vue&type=template&id=5fed146d"
import script from "./ProjectDetailPage.vue?vue&type=script&lang=js"
export * from "./ProjectDetailPage.vue?vue&type=script&lang=js"

import "./ProjectDetailPage.vue?vue&type=style&index=0&id=5fed146d&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__